/**
  * fetch
  * @params:请求参数
  * url 请求接口
  * obj 请求数据(post)
  * vm  vue实例
  * 使用方法：
  * 引入 import httpClient from 'common/script/http';
  * get  : httpClient.getData(url，vue).then().catch()
  * post : httpClient.postData(url, obj, vue).then().catch()
  */
import * as config from './config'
import Vue from 'vue'
import axios from 'axios'
import Toasted from 'vue-toasted'

var instance = null

Vue.use(Toasted, {
  theme: 'toasted-primary',
  position: 'top-center',
  duration: 3000
})

axios.defaults.timeout = 10000
// 请求的拦截，发生错误或超时
axios.interceptors.request.use(config => {
  return config
}, err => {
  Vue.toasted.show(instance.$t('tips.timeout'))
  return Promise.resolve(err)
})

// 响应的拦截
axios.interceptors.response.use(response => {
  // 返回响应时做一些处理
  const data = response.data
  // 根据返回的code值来做不同的处理（和后端约定）
  switch (data.code) {
    case config.R_CODE.SUCCESS:
      return data
    case config.R_CODE.INTERNAL_ERROR:
      Vue.toasted.show(instance.$t('tips.internalError'))
      break
    // 需要重新登录
    case config.R_CODE.INVALID_TOKEN:
      if (response.request.responseURL.indexOf('user/info') < 0) {
        window.location.href = '/?callback=' + encodeURIComponent(window.location)
      }
      break
    default:
  }
  return data
}, err => {
  // 当响应异常时做一些处理
  if (err && err.response) {
    switch (err.response.status) {
      case 400: err.message = instance.$t('tips.errorStatus')
        break
      default: err.message = instance.$t('tips.connectError') + err.response.status + ')!'
    }
  } else {
    err.message = instance.$t('tips.networkError')
  }
  console.log(err)
  Vue.toasted.show(err.message)
  return Promise.resolve(err)
})

export default class HttpClient {
  // get方法
  static getData (url, vue) {
    instance = vue
    url = config.appendParam(url, 'random', new Date().getTime())
    return axios({
      url: url,
      method: 'get',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'App-Key': 'CZUR_PASSPORT_WEB',
        'Api-Build': '7',
        'T-ID': config.cookieGet(config.COOKIE_KEY.TOKEN),
        'U-ID': config.cookieGet(config.COOKIE_KEY.U_ID),
        'Channel': config.CHANNEL
      }
    })
  }

  // post方法
  static postData (url, params, vue) {
    instance = vue
    // console.log(params)
    params = config.jsonToFormData(params)
    return axios({
      url: url,
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'App-Key': 'CZUR_PASSPORT_WEB',
        'Api-Build': '7',
        'T-ID': config.cookieGet(config.COOKIE_KEY.TOKEN),
        'U-ID': config.cookieGet(config.COOKIE_KEY.U_ID),
        'Channel': config.CHANNEL
      },
      data: params
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/script/http.js